import { render, staticRenderFns } from "./TrueFalseCombo.vue?vue&type=template&id=27b08a39&scoped=true"
import script from "./TrueFalseCombo.vue?vue&type=script&lang=ts&setup=true"
export * from "./TrueFalseCombo.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TrueFalseCombo.vue?vue&type=style&index=0&id=27b08a39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b08a39",
  null
  
)

export default component.exports